export default __webpack_public_path__ + "static/media/cave.a9d1af0f.mp3";